import { useTranslations } from "next-intl";
import { TUseSonner } from "./Sonner.config";

export const useSonner = (): TUseSonner => {

  const t = useTranslations("Shared.Labels");

  return {
    dismissLabel: t("dismiss"),
  };
};
